import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import MenuItem from '@material-ui/core/MenuItem';
import './sign-up.scss';
import signInLogo from "../../assets/header_logo.png";




const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    alignItems: 'center',
    textAlign:'center',
  },
}));

const currencies = [
  {
    value: 'دعوي',
    label: 'دعوي',
  },
  {
    value: 'إغاثي',
    label: 'إغاثي',
  },
  {
    value: 'صحي',
    label: 'صحي',
  },
  {
    value: 'تعليمي',
    label: 'تعليمي',
  },
  {
    value: 'اجتماعي',
    label: 'اجتماعي',
  },
  {
    value: 'تدريب ، تأهيل',
    label: 'تدريب ، تأهيل',
  },
  {
    value: 'إعلامي',
    label: 'إعلامي',
  },

];

export default function SignUp() {
  const classes = useStyles();
  const [currency, setCurrency] = React.useState('دعوي');

  const handleChange = (event) => {
    setCurrency(event.target.value);
  };

  return (
      <div className="sign-up">
      
            <Container component="main" maxWidth="xs">
                    <div className={classes.paper}>
                       <img className="sign-in-img-logo" src={signInLogo} alt="singin image"/>                       
                        <form className={classes.form} noValidate>
                        <Grid container spacing={2}>
                          
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="applicantName"
                                  label="‏اسم الجهة "
                                  name="applicantName"
                                  type="text"
                                //   autoComplete="fname"
                                  autoFocus
                              />
                          </Grid>
                           <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="email"
                                  label="عنوان البريد الإلكتروني "
                                  name="email"
                                  type="email"
                                //   autoComplete="email"
                              />
                          </Grid>
                           <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="applicantPhoneNumber"
                                  label="رقم الجوال "
                                  name="applicantPhoneNumber"
                                  type="tel"
                                //   autoComplete="phoneNumber"
                              />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="applicantENumber"
                                label="رقم تصريح الجهة "
                                name="applicantENumber"
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="applicantPassword"
                                label="كلمة المرور "
                                name="applicantPassword"
                                type="password"
                                // autoComplete="password"
                                helperText="يفضل أن تحتوي على أحرف وأرقام ورموز"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="applicantPasswordConfirm"
                                label="تأكيد كلمة المرور "
                                // autoComplete="password"
                                name="applicantPasswordConfirm"
                                type="password"
                            />
                        </Grid>
                         <Grid item xs={12} sm={6}>
                              <TextField
                                  
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="applicantDate"
                                  label="تاريخ تأسيس الجهة "
                                  name="applicantDate"
                                //   type="date"
                                //   autoComplete="date"
                              />
                          </Grid>
                           <Grid item xs={12} sm={6}>
                              <TextField
                                  // value={currency}
                                  onChange={handleChange}
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="selectField"
                                  label="مجال الجهة "
                                  name="selectField"
                                  type="select"
                                  select
                                  
                              >
                              {currencies.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                              </TextField>
                            
                            
                           
                          </Grid>

                          <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="applicantCEO"
                                  label="المدير التنفيذي للجهة "
                                  name="applicantCEO"
                                  type="text"
                                //   autoComplete="fname"
                              />
                          </Grid>

                           <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="applicantCEOPhoneNumber"
                                  label="رقم جوال المدير التنفيذي للجهة "
                                  name="applicantCEOPhoneNumber"
                                  type="tel"
                                //   autoComplete="phoneNumber"
                              />
                          </Grid>

                          <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="region"
                                  label="المنطقة "
                                  name="region"
                                  type="text"
                                //   autoComplete="address"
                              />
                          </Grid>

                           <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="city"
                                  label="المدينة "
                                  name="city"
                                  type="text"
                                //   autoComplete="city"
                              />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="applicantBankIBAN"
                                label="رقم الحساب البنكي ( يفضل الراجحي ) "
                                name="applicantBankIBAN"
                                type="text"
                                helperText="الآيبان"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="applicantBank"
                                label=" اسم البنك "
                                name="applicantBank"
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="applicantBankName"
                                label=" اسم الجهة المسجل لدى البنك "
                                name="applicantBankName"
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="applicantBankImage"
                            label=" صورة بطاقة بيانات الحساب البنكي "
                            name="applicantBankImage"
                            // type="file"
                            helperText="صورة بطاقة الحساب البنكي"
                        />
                    </Grid>

                    {/* Optional Re*/}

                    <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="applicantBankIBAN2"
                                label="رقم الحساب البديل "
                                name="applicantBankIBAN2"
                                type="text"
                                helperText="الآيبان"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="applicantBank2"
                                label=" اسم البنك للحساب البديل "
                                name="applicantBank2"
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="applicantBankName2"
                                label=" اسم الجهة المسجل لدى البنك "
                                name="applicantBankName2"
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="applicantBankImage2"
                            label=" صورة بطاقة بيانات الحساب البديل "
                            name="applicantBankImage2"
                            // type="file"
                            helperText="صورة بطاقة الحساب البنكي"
                        />
                    </Grid>

                        
                           
                    
                        </Grid>
                        
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                            >
                            إنشاء حساب  
                          </Button>
                    
                            <div>
                                <Link href="/login" variant="body2">
                                    {" لديك اسم مستخدم بالفعل؟ تسجيل الدخول"}
                                </Link>
                            </div>
                            
                            
                        
                        </form>
                    </div>
                
            </Container>
    </div>
  );
}